module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_f_normal.4502e1ea.png";